export default __webpack_public_path__ + "static/media/preguntas-frecuentes.6a22570c.svg";